export const MAZDA_PREAUTHORIZATION_SERVICE_CODE = 'MAZDA_PORTAL-PREAUTH';
